/**
 * badgeHandlers.js - Socket-Handler für Badge-Events
 *
 * Zeigt Toast-Benachrichtigungen wenn Abzeichen freigeschaltet werden.
 * Alle Spieler im Raum sehen die Benachrichtigung.
 */

import socketService from '../../socketService';
import soundService from '../../soundService';
import { getRarityConfig } from '../../shared/entities/rarity';

/**
 * Registriert Badge-Socket-Handler
 * @param {Function} notify - Notification-Funktion von useNotifications
 */
export function setupBadgeHandlers(notify) {
  // Handler für Badge-Freischaltung
  const handleBadgeUnlocked = ({ playerIndex, playerName, badges }) => {
    // Sound für Badges
    soundService.play('achievement');

    // Toast für jedes freigeschaltete Badge
    badges.forEach(badge => {
      const rarityConfig = getRarityConfig(badge.rarity);

      notify(`${badge.icon} ${playerName}: ${badge.name}`, {
        icon: '🏅',
        style: badge.rarity === 'legendary' || badge.rarity === 'secret' ? 'legendary' : 'special',
        duration: 4000,
        color: rarityConfig?.color || '#a855f7',
      });
    });

    console.log(`[BadgeHandlers] ${playerName} unlocked: ${badges.map(b => b.name).join(', ')}`);
  };

  // Listener registrieren
  socketService.registerListener('badgeUnlocked', handleBadgeUnlocked);

  // Cleanup-Funktion zurückgeben
  return () => {
    socketService.off('badgeUnlocked');
  };
}

export default setupBadgeHandlers;
